import { StreamData } from 'types/streamData'
import WidgetType from 'enums/WidgetType'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const sentimentsResolver: FieldResolver = (metadata: Metadata) => {
  const widgetType = metadata.getWidgetType()
  let sentiments
  if (widgetType && widgetType === WidgetType.SOCIAL_WEB_POPULAR_POSTS) {
    sentiments = metadata.getSentiments()
  }

  return { sentiments } as StreamData
}

export default sentimentsResolver
